import useOtp from "../hooks/useOtp";
import useRemoteAssets from "../utils/useRemoteAssets";

export default function Otp() {

  


  const {
    otp,
    handleChange,
    handleSubmit,
    maskedEmail,
    Button,
    Input,
    loading,
    submitting,
    authToken,
  } = useOtp();


  const ASSETS = useRemoteAssets();
  if (
    loading ||
    !Button ||
    !Input ||
    !ASSETS
  ) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <div className="w-10 h-10 border-4 border-gray-300 rounded-full border-t-red-600 animate-spin" />
      </div>
    );
  }

  return (
    <div className="w-full max-w-[280px] md:max-w-[511px] mx-auto min-h-[30vh] flex flex-col justify-between">

      <div className="relative w-full">

        <Input
          token={authToken}
          value={otp}
          onChange={handleChange}
          placeholder={`Enter OTP received on your ${maskedEmail}`}
          className="
            w-full
            h-[45px]
            md:h-[51px]
            rounded-xl
            border
            px-4
            text-[12px]
            md:text-[16px]
          "
        />

        <img
          src={ASSETS.eye}
          className="absolute w-5 h-5 -translate-y-1/2 right-3 top-1/2"
          alt="icon"
        />

      </div>

      <Button
        token={authToken}
        onClick={handleSubmit}
        disabled={
          otp.length !== 4 ||
          submitting
        }
        className={`
          w-full
          h-[45px]
          md:h-[51px]
          rounded-xl
          font-bold
          font-montserrat
          ${
            otp.length === 4 &&
            !submitting
              ? "bg-[#CF0018] text-white"
              : "bg-gray-300 text-[#827C7C]"
          }
        `}
      >
        {submitting
          ? "Verifying..."
          : "Submit"}
      </Button>

    </div>
  );
}